module.exports = __webpack_public_path__ + "img/user-card-top-bg.692cb9b6.png";